import gql from 'graphql-tag';

export const sync = gql`
  mutation sync($type: AdamSenderTypeEnum!, $identifier: Int!) {
    adamSenderSync(type: $type, identifier: $identifier)
  }
`;

export const condominiumResync = gql`
  mutation adamSenderCondominiumResync($condominiumContextId: ID!) {
    adamSenderCondominiumResync(condominiumContextId: $condominiumContextId)
  }
`;

export const startEmergency = gql`
  mutation EmergencyStart($condominiumContextId: ID!) {
    startEmergency(condominiumContextId: $condominiumContextId)
  }
`;

export const stopEmergency = gql`
  mutation EmergencyStop($condominiumContextId: ID!) {
    stopEmergency(condominiumContextId: $condominiumContextId)
  }
`;

export const openDeviceV2 = gql`
  mutation openDeviceV2($deviceHandler: DeviceHandlerInput) {
    openDeviceV2(deviceHandler: $deviceHandler)
  }
`;

export const closeDeviceV2 = gql`
  mutation closeDeviceV2($deviceHandler: DeviceHandlerInput) {
    closeDeviceV2(deviceHandler: $deviceHandler)
  }
`;

export const keepDeviceOpenedV3 = gql`
  mutation keepDeviceOpenedV3($deviceHandler: DeviceHandlerInput) {
    keepDeviceOpenedV3(deviceHandler: $deviceHandler)
  }
`;

export const triggerAlarmOutput = gql`
  mutation triggerAlarmOutput($deviceHandler: DeviceHandlerInput) {
    triggerAlarmOutput(deviceHandler: $deviceHandler)
  }
`;

export const handleRelay = gql`
  mutation handleRelay($relayHandler: RelayHandlerInput) {
    handleRelay(relayHandler: $relayHandler)
  }
`;
